<template>
  <div>
    <div class="base-margin__left-20">
      <p>{{ $t('customCluster.activity.createNetworkInterfaceActivity.operation') }}</p>
      <p class="base-margin__bottom-5 base-margin__left-20">
        {{
          $t('customCluster.activity.createNetworkInterfaceActivity.createCount', {count: detailsDataInfo.eventResourceCount})
        }}
      </p>
      <div v-if="detailsDataInfo.activityStatus !== SubclusterActivityStatusRunning">
        <p>{{ $t('customCluster.activity.createNetworkInterfaceActivity.result') }}</p>
        <div class="base-margin__left-20">
          <p class="base-margin__bottom-5">
            {{
              $t('customCluster.activity.createNetworkInterfaceActivity.successCount', {
                count: detailsDataInfo.successNumber,
                ids: detailsDataInfo.networkInterfaceIdList
              })
            }}
          </p>
          <p class="base-margin__bottom-5 base-color__red">
            {{
              $t('customCluster.activity.createNetworkInterfaceActivity.failedCount', {
                count: detailsDataInfo.errorNumber,
                action: filterActivity(detailsDataInfo.activityType)
              })
            }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="detailsDataInfo.errorMessage" class="base-margin__left-20">
      <p class="base-margin__bottom-5 base-color__red base-margin__left-20">
        {{
          $t('customCluster.activity.createNetworkInterfaceActivity.reason', {
            action: filterActivity(detailsDataInfo.activityType),
            errorMessage: detailsDataInfo.errorMessage
          })
        }}
      </p>
    </div>
  </div>
</template>
<script>
import {SubclusterActivityStatusRunning, SubclusterActivityTypeCreateNetworkInterface} from "@/common/constants";

export default {
  name: 'createNetworkInterfaceActivity',
  props: {
    detailsData: Object,
  },
  data() {
    return {
      detailsDataInfo: {},
      SubclusterActivityStatusRunning
    };
  },

  mounted() {
    const successList = [];
    const errorList = [];
    let networkInterfaceIdList = '';
    this.detailsData.detailData.map((item) => {
      if (item.status === 3) {
        networkInterfaceIdList += `${item.networkInterfaceId} `;
        successList.push(item);
      }
      if (item.status === 4) {
        errorList.push(item);
      }
    });

    this.detailsDataInfo = {
      ...this.detailsData,
      networkInterfaceIdList,
      successList,
      errorList,
      successNumber: successList.length,
      errorNumber: errorList.length
    };
  },

  methods: {
    filterActivity(activityId) {
      switch (activityId) {
        case SubclusterActivityTypeCreateNetworkInterface:
          return this.$t('customCluster.activity.createNetworkInterfaceActivity.create');
      }
    },
  },
};
</script>
